import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

let state = {
    isLogin: 0,
    isBuy: 0,
    hasOrder: 0, //home页请求接口查看是否有权限
    buyNow: true, //立即订阅按钮是否显示
    phoneNum: '',
    indexArr: [],
    myOrder: false
};

const mutations = {
    loginIn(context){
        state.isLogin = 1;
    },
    loginOut(context){
        state.isLogin = 0;
    },
    updatedIndexArr(context) {
        state.indexArr = context;
    },
};

// 事件触发后的逻辑操作
// 参数为事件函数
const actions = {
    // add(add){
    //     add.commit('add')
    // },
    // decrease(decrease){
    //     decrease.commit('decrease')
    // },
    // oddAdd({commit,state}){
    //     if (state.count % 2 === 0) {
    //         commit('add')
    //     }
    // }
};

// 返回改变后的数值
const getters = {
    getIsLogin(context){
        return context.isLogin
    },
    getIsBuy(context) {
        return context.isBuy
    }
};

export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters
})


// WEBPACK FOOTER //
// ./src/store.js